/**
 * @generated SignedSource<<cb46a9ae1d8f38a011c819d31f4d0249>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateMetadataListingCard_MetadataAccount$data = {
  readonly data: {
    readonly uri: string;
  };
  readonly mint: string;
  readonly " $fragmentSpreads": FragmentRefs<"ListingCardForMetadata_MetadataAccount">;
  readonly " $fragmentType": "UpdateMetadataListingCard_MetadataAccount";
};
export type UpdateMetadataListingCard_MetadataAccount$key = {
  readonly " $data"?: UpdateMetadataListingCard_MetadataAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateMetadataListingCard_MetadataAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateMetadataListingCard_MetadataAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetadataAccountData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uri",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mint",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListingCardForMetadata_MetadataAccount"
    }
  ],
  "type": "MetadataAccount",
  "abstractKey": null
};

(node as any).hash = "694975732b09b73b538e4ee4ae185536";

export default node;
